// EL TIEMPO SE RECIBE EN MILISEGUNDOS
export function formatTime(currentTime: number) {
  if (currentTime >= 0) {
    let minutes = Math.floor(currentTime / 60000);
    let seconds = Math.floor((currentTime % 60000) / 1000);
    let millisecond = currentTime % 1000;
  
    if (minutes > 0) {
      return `${minutes}M:${seconds}S:${millisecond}MS`;
    } else {
      return `0M:${seconds}S:${millisecond}MS`;
    }
  }
}

// EL TIEMPO SE RECIBE EN MILISEGUNDOS
export function formatTimeChronometer(currentTime: number) {
  if (currentTime >= 0) {
    let minutes = Math.floor(currentTime / 60000);
    let seconds = Math.floor((currentTime % 60000) / 1000);  
    if (minutes > 0) {
      return `0${minutes}:${seconds > 9 ? seconds : "0" + seconds}`;
    } else {
      return `00:${seconds > 9 ? seconds : "0" + seconds}`;
    }
  }
}
